var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.54761 3.15274H5.65191C3.54072 3.15274 2.48513 3.15274 1.82926 3.8086C1.1734 4.46447 1.1734 5.52006 1.1734 7.63125V8.0791M6.54761 16.5883H5.65191C3.54072 16.5883 2.48513 16.5883 1.82926 15.9324C1.1734 15.2765 1.1734 14.2209 1.1734 12.1098V11.6619",
    stroke: "#1C274C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7194 1.22464C8.78283 0.886871 7.81458 0.717986 7.18109 1.27958C6.54761 1.84118 6.54761 2.86846 6.54761 4.92303V14.818C6.54761 16.8726 6.54761 17.8999 7.18109 18.4615C7.81458 19.0231 8.78283 18.8541 10.7194 18.5164L12.8053 18.1526C14.9501 17.7785 16.0224 17.5915 16.6593 16.8048C17.296 16.0182 17.296 14.8804 17.296 12.605V7.13604C17.296 4.86061 17.296 3.72289 16.6593 2.93624C16.2337 2.41052 15.6136 2.1526 14.6089 1.92769",
    stroke: "#1C274C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.e59ed83aa5013a8b4f97609307d49fec.svg";
export { ForwardRef as ReactComponent };